var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGapSwitchLowColdWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.002,
    height: 69,
    viewBox: "0 0 202.002 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Low_Cold_Water",
    "data-name": "Low Cold Water",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4310",
    "data-name": "Rectangle 4310",
    width: 202,
    height: 69,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M86.23,68.35c-.08,0-.13-.01-79.38-12.43A7.02,7.02,0,0,1,.92,49.1L.65,9.97A4.136,4.136,0,0,1,1.83,6.99,4.084,4.084,0,0,1,4.77,5.75c54.08-.06,102.28-.1,135.71-.1,29.11,0,47.86.03,55.74.08a4.767,4.767,0,0,1,4.75,4.75l.37,53.37a4.439,4.439,0,0,1-4.43,4.5Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M86.2,67.56c-.05,0-79.14-12.38-79.14-12.38-3.61-.3-5.44-3-5.5-6.11L1.3,10.32A3.859,3.859,0,0,1,4.9,6.45c24.96-.03,164.94-.1,191.52.08a3.973,3.973,0,0,1,3.88,4.15l.4,53.14c.03,2.12-1.15,3.78-3.55,3.78Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M130.42,55.68c-6.05-5.97-11.55-1.18-12.58-.18v-.05s-6.28,5.16-11.52,0-10.46,0-10.46,0-6.8,5.85-12.73,0-10.99,0-10.99,0-6.45,6.19-12.73,0-11.86,0-11.86,0-5.84,7.6-12.55.98c-5.94-5.86-11.34-1.36-12.51-.24a11.3,11.3,0,0,1-3.92,1.56C86.1,68.34,86.15,68.34,86.23,68.35H196.91a4.439,4.439,0,0,0,4.43-4.5l-.07-9.57c-5.08-4.44-10.01.42-10.01.42s-6.8,5.85-12.73,0-10.99,0-10.99,0-6.45,6.19-12.73,0-11.86,0-11.86,0S137.13,62.3,130.42,55.68Z",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M6.85,55.92c2.36.37,4.64.73,6.86,1.07a8.288,8.288,0,0,1-1.87-1.4,6.807,6.807,0,0,0-8.55-1.35A6.946,6.946,0,0,0,6.85,55.92Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M140.51,6.3c25.53,0,46.91.02,55.71.08a4.132,4.132,0,0,1,4.1,4.1l.37,53.37a3.784,3.784,0,0,1-3.78,3.84H86.23c-.05,0-79.28-12.42-79.28-12.42a6.385,6.385,0,0,1-5.38-6.19L1.3,9.96A3.5,3.5,0,0,1,4.78,6.4c16.57-.02,84.51-.1,135.73-.1m0-1.3c-23.33,0-65.82.02-135.67.1H4.77A4.765,4.765,0,0,0,1.36,6.53,4.832,4.832,0,0,0,0,9.99L.27,49.1a7.686,7.686,0,0,0,6.48,7.47C86.02,68.99,86.06,68.99,86.13,69H196.91A5.088,5.088,0,0,0,202,63.84l-.37-53.36a5.416,5.416,0,0,0-5.4-5.4C188.36,5.03,169.61,5,140.51,5Z",
    fill: "#808184"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGapSwitchLowColdWater);
export default __webpack_public_path__ + "static/media/air_gap_switch_low_cold_water.12d2339405b12d070b53d38fcf8b2a79.svg";
export { ForwardRef as ReactComponent };